const fullPage = {
  lockScroll: () => {
    if ($.fn.fullpage) {
      $.fn.fullpage.setAllowScrolling(false, 'up, down')
    }
  },
  scroll: () => {
    if ($.fn.fullpage) {
      $.fn.fullpage.setAllowScrolling(true, 'up, down')
    }
  }
}

export default fullPage
